import * as tslib_1 from "tslib";
import { Prop, Vue, Watch } from "vue-property-decorator";
import { OrganizationType, StaffSelectorControl, UserStatus, } from "./controls/staff-selector-control";
import { DefaultUserService } from './user-service';
const SERVICE = StaffSelectorControl.service || DefaultUserService;
import getDownloadUrlNew from '../../../../../common/src/utils/getDownloadUrlNew';
const MAPPING_FIELD_OPERATE = "MAPPING_FIELD_OPERATE_"; // 选人控件 特殊的映射字段 额外处理方法名 前缀
export class StaffSelectorBase extends Vue {
    constructor() {
        super(...arguments);
        this.mainDepartment = null; // 主部门
        this.partTimerDepartment = null; // 兼职部门
        this.org = [];
        // 是否是通过单击打开的部门（是：单击下级或路径，否：单击根目录或初始化打开选人控件）
        this.isClickNext = false;
        this.searchList = [];
        this.showLoading = false; // 是否展示正在搜索中
        this.isDisableClick = false;
        // 搜索数据总数
        this.departmentsTotal = 0;
        this.usersTotal = 0;
        this.selected = [];
        this.blackList = ["#/system/manager-setting"];
        this.isFirstLoad = true;
        this.showNotData = false;
        this.roleLabel = this.getRoleLabel;
    }
    get locale() {
        return localStorage.getItem("locale") || "zh";
    }
    setValue(vals) {
        if (!vals) {
            this.selected = [];
            return;
        }
        this.selected = this.getSelectData(vals);
    }
    handleFocus(opts) {
        if (!opts.showSelect && opts.showModel) {
            this.treeFocus();
        }
    }
    getSelectData(vals) {
        const vm = this;
        let arr = [];
        try {
            if (typeof vals === 'string') {
                vals = JSON.parse(vals);
            }
        }
        catch (error) {
        }
        if (Array.isArray(vals)) {
            arr = vals;
        }
        else {
            arr = [vals];
        }
        return arr.map((x) => {
            return {
                id: (x[this.convertKey] ? x[this.convertKey] : x.id) || x.key,
                key: (x[this.convertKey] ? x[this.convertKey] : x.id) || x.key,
                name: x.name || "",
                type: Number(x.type) === 3 || Number(x.unitType) === 3 ? "user" : "org",
                source: x,
                avatar: x.imgUrl ? x.imgUrl.includes('http') ? x.imgUrl : vm.getDownloadUrlNew(x.imgUrl) : "",
                /**
                 * 基于此bug #43245 做一个拓展
                 * 拓展逻辑：当前部门不在子管理员的组织管理范围内的，只可查看，不可删除
                 * 故增加此字段以做删除逻辑时判断
                 * 2020-05-07 by John
                 * */
                operatable: x.operatable,
            };
        });
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem('token');
    }
    getDownloadUrlNew(refId) {
        return getDownloadUrlNew.getImageUrl(refId);
    }
    convert(x) {
        return {
            id: x[this.convertKey] || x.key,
            key: x[this.convertKey] || x.key,
            name: x.name,
            type: x.type === 3 ? "user" : "org",
            source: x,
            avatar: x.imgUrl,
            /**
             * 基于此bug #43245 做一个拓展
             * 拓展逻辑：当前部门不在子管理员的组织管理范围内的，只可查看，不可删除
             * 故增加此字段以做删除逻辑时判断
             * 2020-05-07 by John
             * */
            operatable: x.operatable,
        };
    }
    get rootId() {
        let id = "";
        if (this.options &&
            this.options.rootNode &&
            this.options.rootNode.length > 0) {
            id = this.options.rootNode[0].id || "";
        }
        return id;
    }
    get rootIds() {
        let resId = "";
        if (this.options &&
            this.options.rootNode &&
            this.options.rootNode.length > 0) {
            // resId = this.options.rootNode[0].id || '';
            resId = this.options.rootNode
                .map((node) => node.id)
                .filter((id) => !!id)
                .join(",");
        }
        return resId;
    }
    get roleId() {
        if (Object.prototype.toString.call(this.options.role) === '[object Object]') {
            this.options.role = [this.options.role,];
        }
        if (this.options && this.options.role) {
            let roleId = this.options.role.map((item) => {
                return item.value;
            });
            return roleId || "";
        }
        return [];
    }
    get getRoleLabel() {
        if (Object.prototype.toString.call(this.options.role) === '[object Object]') {
            this.options.role = [this.options.role,];
        }
        if (this.options && this.options.role) {
            let getRoleLabel = this.options.role.map((item) => {
                return item.label;
            });
            return getRoleLabel || "";
        }
        return [];
    }
    get filterType() {
        if (this.options.appManagerFilter || this.appManagerFilter) {
            return "admin";
        }
        else {
            return "";
        }
    }
    treeFocus() {
        this.org = []; // 每次进入，先清空树
        this.$emit('focus');
        this.onClickTrunBack();
    }
    // 树-返回
    onClickTrunBack() {
        this.isClickNext = false;
        this.currentDept = undefined;
        this.getOrgsAndUsers();
    }
    // 树-下一级
    onClickNextHierarchy(val) {
        this.isDisableClick = true;
        //如果是角色下一级，则把角色id传过去
        if (val && val.id && val.roles === 'role') {
            this.isClickNext = true;
            this.currentDept = val.source;
            this.getOrgsAndUsers(val.roleId);
        }
        else {
            this.isClickNext = true;
            this.currentDept = val.source;
            this.getOrgsAndUsers();
        }
    }
    onClickBreadcrumb(val) {
        this.isDisableClick = true;
        if (val && val.id) {
            this.isClickNext = true;
            this.currentDept = val.source;
            this.getOrgsAndUsers();
        }
    }
    onChange(items) {
        let selecteds = [];
        if (items && items.length > 0) {
            const ids = items.map((x) => x.key);
            selecteds = this.selected.filter((item) => ids.indexOf(item.id) > -1);
        }
        let list = [];
        if (selecteds.length > 0) {
            list = selecteds.map((x) => x.source);
        }
        this.$emit("change", list);
    }
    onOk(items) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //主部门、兼职部门
            items.map((item) => {
                if (item.source && item.source.departments) {
                    //主部门的id
                    this.mainDepartment = item.source.departments.filter((x) => x.id === item.source.departmentId);
                    //兼职部门的id
                    this.partTimerDepartment = item.source.departments.filter((x) => x.id !== item.source.departmentId);
                }
            });
            // 给数据设置区分主部门和兼职部门
            items.forEach((x) => {
                x.source.departments = this.mainDepartment;
                x.source.partTimerDepartment = this.partTimerDepartment;
            });
            //注释说明 单选模式统一在staff-selector-control映射字段-manager-主管
            // items.length && (await this.onlyFormModal(items));
            if (items.length === 1) {
                this.getOrganizationLevel(items);
            }
            else {
                yield this.onlyFormModal(items);
                const list = items.map((x) => x.source);
                this.$emit("ok", list);
                this.$emit("change", list);
            }
        });
    }
    // 单选模式下 ok 或 change事件需要处理的 业务
    onlyFormModal(items) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.mappingOperate(items[0]);
        });
    }
    // 选人控件 映射相关的业务
    mappingOperate(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let self = this;
            if (this.controlOpts && this.controlOpts.mappings) {
                let mappings = this.controlOpts.mappings;
                if (mappings) {
                    // 获取所有映射的 字段
                    let arr_mapping = mappings
                        .slice(0, -1)
                        .split(";")
                        .map((val) => val.split(":")[0]);
                    for (let mapping_item of arr_mapping) {
                        if (self[MAPPING_FIELD_OPERATE + mapping_item]) {
                            yield self[`${MAPPING_FIELD_OPERATE}${mapping_item}`](item);
                        }
                    }
                }
            }
        });
    }
    // 映射字段-manager-主管 获取信息
    [MAPPING_FIELD_OPERATE + "manager"](item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let params = Object.assign({ userId: item.id }, this.params);
            // portal端参数处理
            if (this.controlOpts && this.controlOpts.params) {
                let opts = JSON.parse(this.controlOpts.params);
                params = Object.assign({}, params, opts);
            }
            return new Promise((resolve, reject) => {
                SERVICE.getDeptLeader(Object.assign({ userId: item.id }, params))
                    .then((data) => {
                    if (data.length) {
                        item.source["manager"] = data;
                    }
                    // else {
                    //   item.source["manager"] = [{ name: "陈总", id: 12323 }];
                    // }
                    resolve(item);
                });
            });
            // const list = items.map(x => x.source);
            // this.$emit("ok", list);
            // this.$emit("change", list);
        });
    }
    onCancle() {
        this.showLoading = false;
        this.$emit("cancel");
    }
    // 获取组织层级（部门）
    getOrganizationLevel(items) {
        const list = items.map((x) => x.source);
        this.$emit("ok", list);
        this.$emit("change", list);
        return false;
        // 单选模式统一在staff-selector-control里面映射的组织层级对应
        // StaffSelectorControl.service
        //   .getOrganizationLevel(items[0].id)
        //   .then((data) => {
        //     if (this.controlOpts && this.controlOpts.mappings) {
        //       const mappings = this.controlOpts.mappings;
        //       let item: any = items[0];
        //       if (data) {
        //         if (data.length > 0) {
        //           if (mappings) {
        //             if (mappings.indexOf("LEVEL") > -1) {
        //               mappings.split(";").forEach((m: any) => {
        //                 if (m.indexOf("LEVEL") > -1) {
        //                   let level = m.split(":")[0];
        //                   //判断当前返回的组织层级是否与映射的组织层级对应
        //                   if (level.split(",")[1] < data.length) {
        //                     item.source[level] = [];
        //                     item.source[level].push(data[level.split(",")[1]]);
        //                   } else {
        //                     item.source[level] = [];
        //                     item.source[level].push(data[data.length - 1]);
        //                   }
        //                 }
        //               });
        //             }
        //           }
        //         }
        //       }
        //     }
        //     const list = items.map((x) => x.source);
        //     this.$emit("ok", list);
        //     this.$emit("change", list);
        //   });
    }
    // 获取该级的树和用户
    getOrgsAndUsers(roleId) {
        let promises = [];
        const rootId = this.rootId;
        //如果有角色组id则根据角色id获取所有用户
        if (roleId) {
            promises.push(this.getUsers(this.rootIds, rootId, undefined, roleId));
        }
        else {
            if (this.currentDept) {
                const dept = this.currentDept;
                if (this.options.appManagerFilter || this.appManagerFilter) {
                    promises.push(this.getDepts(this.rootIds, dept.id, "admin"));
                    promises.push(this.getUsers(this.rootIds, dept.id, "admin"));
                }
                else {
                    promises.push(this.getDepts(this.rootIds, dept.id));
                    promises.push(this.getUsers(this.rootIds, dept.id));
                }
            }
            else {
                const roots = this.options.rootNode;
                if (!roots || roots.length < 2) {
                    if (this.options.appManagerFilter || this.appManagerFilter) {
                        promises.push(this.getDepts(this.rootIds, rootId, "admin"));
                    }
                    else if (this.roleId.length) {
                        /* //表单设计时设置了角色范围或者有组织根节点时查询该角色下所有用户
                        promises.push(this.getUsers(this.rootIds, rootId,)); */
                    }
                    else {
                        promises.push(this.getDepts(this.rootIds, rootId));
                    }
                }
                else if (roots && roots.length > 1) {
                    promises.push(this.getDepts(this.rootIds, this.rootIds));
                }
            }
        }
        this.showNotData = false;
        //如果是按照角色展示并且没有角色id存在，即展示所有的角色组当成部门展示
        if (this.roleId.length && !roleId) {
            this.setRoles();
        }
        else {
            Promise.all(promises)
                .then((res) => {
                let orgs = [];
                res.forEach((x) => (orgs = orgs.concat(x)));
                if (orgs.length === 0) {
                    this.showNotData = true;
                }
                this.org = orgs;
                this.isDisableClick = false;
            })
                .catch(() => {
                console.log('失败......');
                this.showNotData = true;
                this.org = [];
                this.isDisableClick = false;
            });
        }
    }
    //把角色组伪装成一个部门作为展示
    setRoles() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let arr = [];
            this.roleId.map((item, index) => {
                arr.push({
                    avatar: "",
                    hasChild: true,
                    hasPermission: true,
                    isleaf: false,
                    orglist: "",
                    parentId: null,
                    sortKey: "0",
                    title: this.roleLabel[index],
                    type: "org",
                    id: item,
                    key: item,
                    name: this.roleLabel[index],
                    roles: "role",
                    roleId: item,
                });
            });
            this.org = arr;
        });
    }
    getDepts(rootId, deptIds, filterType, deptIdTwo) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // 额外需要的过滤参数
            const copyParams = this.params
                ? JSON.parse(JSON.stringify(this.params))
                : {};
            // 需要从根节点开始显示部门
            if (this.isClickNext && (this.options.isDisplayRoot || copyParams.filterType === 'root_display')) {
                delete copyParams.filterType;
            }
            let params = Object.assign({ formRootDeptIds: rootId, deptIds,
                filterType }, copyParams);
            // portal端参数处理
            if (this.controlOpts && this.controlOpts.params) {
                let opts = JSON.parse(this.controlOpts.params);
                params = Object.assign({}, params, opts);
            }
            params = this.processParams(params);
            const res = yield SERVICE.getDepartmentsBy(params.deptIds || "", params.filterType || "", params.sourceType || "", params.corpId || "", params.excludeCorpId || "", params.selectUserIds || "", params.workflowInstanceId || "", params.activityCode || "", params.formRootDeptIds || "");
            const nodes = res.departments;
            const orgTree = this.resetTree(nodes, []);
            let myDepartentTree = [];
            let exitSameDepartent = true;
            if (res.myDepartment) {
                const myDepartent = res.myDepartment;
                // myDepartent. = '';
                myDepartentTree = this.resetTree(myDepartent, []);
                // 增加我的部门显示
                myDepartentTree.forEach((res2) => {
                    res2.copyName = "我的部门";
                });
                // 判断我的部门是不是和当前部门一致 一致的话就不现实
                const myDepartentID = myDepartentTree[0].id;
                exitSameDepartent = orgTree.some((i) => i.id === myDepartentID);
            }
            return exitSameDepartent ? orgTree : [...orgTree, ...myDepartentTree];
        });
    }
    getUsers(rootId, deptId, filterType, roleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let param = {};
            if (this.params) {
                // @ts-ignore
                param = JSON.parse(JSON.stringify(this.params));
            }
            // if (param.hasOwnProperty('sourceType')) {
            //   // @ts-ignore
            //   delete param.sourceType
            // }
            let params = Object.assign({ formRootDeptIds: rootId, deptId, roleId: roleId || "", filterType }, param);
            // params = this.processParams(params);
            // @ts-ignore
            const users = yield SERVICE.getUsersBy(params.deptId || "", params.roleId || "", params.filterType || "", params.sourceType || "", params.workflowInstanceId || "", params.activityCode || "", params.formRootDeptIds || "");
            // 过滤没激活状态的用户
            let enableUsers = users.filter((u) => u.status === UserStatus.Enable);
            if (this.options &&
                this.options.filterUser &&
                this.options.filterUser.length > 0) {
                //加签状态选择加签人员过滤当前处理人
                this.options.filterUser.forEach((f) => {
                    enableUsers.forEach((e, i) => {
                        if (e.id === f.id) {
                            enableUsers.splice(i, 1);
                        }
                    });
                });
            }
            const userTree = this.resetTree(enableUsers, []);
            return userTree;
        });
    }
    // 组装接口异步数据
    resetTree(nodes, orgTree) {
        const vm = this;
        let corpid = this.params && this.params.corpid || '';
        nodes.forEach((node) => {
            // 是否递归为false，不让进入下级部门
            //因为后端返回的叶子节点，只要下级有部门，就有节点，没有部门就没有节点，，但是还有情况是下级有用户
            let hasChild = true; //修改为部门下级都显示
            if (this.options.recursive === false) {
                hasChild = false;
                node.leaf = true;
            }
            // else {
            //   hasChild = !node.leaf || (node.employees && node.employees > 0);
            // }
            if (corpid) {
                if (corpid === node.corpId) {
                    orgTree.push({
                        id: node.id,
                        name: node.name,
                        // avatar: node.imgUrl,
                        avatar: node.imgUrl ? node.imgUrl.includes('http') ? node.imgUrl : vm.getDownloadUrlNew(node.imgUrl) : "",
                        type: node.type === OrganizationType.User ? "user" : "org",
                        hasChild,
                        hasPermission: node.hasPermission,
                        orglist: node.parentDepartmentName || "",
                        title: `${node.name} (${node.employees || 0})`,
                        isLeaf: node.leaf,
                        key: node.id,
                        sortKey: "0",
                        parentId: node.parentId,
                        children: [],
                        source: node,
                    });
                }
            }
            else {
                orgTree.push({
                    id: node.id,
                    name: node.name,
                    // avatar: node.imgUrl,
                    avatar: node.imgUrl ? node.imgUrl.includes('http') ? node.imgUrl : vm.getDownloadUrlNew(node.imgUrl) : "",
                    type: node.type === OrganizationType.User ? "user" : "org",
                    hasChild,
                    hasPermission: node.hasPermission,
                    orglist: node.parentDepartmentName || "",
                    title: `${node.name} (${node.employees || 0})`,
                    isLeaf: node.leaf,
                    key: node.id,
                    sortKey: "0",
                    parentId: node.parentId,
                    children: [],
                    source: node,
                });
            }
        });
        return orgTree;
    }
    onSearch(name, type) {
        if (!name) {
            return;
        }
        let params = Object.assign({ name, queryType: type || '', formRootDeptIds: this.rootIds, deptIds: this.rootIds, roleIds: this.roleId && this.roleId.join(), filterType: this.filterType }, this.params);
        // portal端参数处理
        if (this.controlOpts && this.controlOpts.params) {
            let opts = JSON.parse(this.controlOpts.params);
            params = Object.assign({}, params, opts);
        }
        params = this.processParams(params);
        // 正在搜索的时候不执行
        if (this.showLoading)
            return;
        this.showLoading = true;
        // @ts-ignore
        SERVICE.search(params.name || "", params.queryType || "", params.deptIds || "", params.roleIds || "", params.filterType || "", params.sourceType || "", params.corpId || "", params.excludeCorpId || "", params.workflowInstanceId || "", params.activityCode || "", params.formRootDeptIds || "")
            .then((data) => {
            const list = [];
            if (data.departments && this.options.selectOrg) {
                this.resetTree(data.departments, list);
            }
            if (data.users && this.options.selectUser) {
                this.resetTree(data.users, list);
            }
            this.departmentsTotal = data.departmentsTotal;
            this.usersTotal = data.usersTotal;
            this.searchList = list;
            this.showLoading = false;
        });
    }
    /**
     * @desc 选人控件前台筛选
     * @param params 请求参数
     */
    processParams(params) {
        return params;
        let path = this.$route.path;
        // admin端不需要做处理
        if (path.includes("admin")) {
            return params;
        }
        let userInfo = sessionStorage.getItem("user");
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
        }
        // 主组织可以看到关联组织的信息管理不能看到主组织的信息
        // MAIN 主
        // Re   关联组织
        if (userInfo.relatedOrgType === "MAIN") {
            // params.sourceType = 'admin'
        }
        else {
            delete params.sourceType;
        }
        // 表单有根节点的时候需要特殊处理
        if (this.isFirstLoad && path === "/form/detail") {
            let { deptIds } = params;
            this.isFirstLoad = false;
            // 如果说有根节点 需要删除sourceType参数
            if (deptIds) {
                delete params.sourceType;
            }
        }
        // 有根节点需要删除sourceType
        return params;
    }
}
tslib_1.__decorate([
    Prop({
        default: () => { },
    })
], StaffSelectorBase.prototype, "options", void 0);
tslib_1.__decorate([
    Prop({
        default: () => { },
    })
], StaffSelectorBase.prototype, "params", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], StaffSelectorBase.prototype, "onlyForm", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], StaffSelectorBase.prototype, "disabled", void 0);
tslib_1.__decorate([
    Prop()
], StaffSelectorBase.prototype, "controlOpts", void 0);
tslib_1.__decorate([
    Prop()
], StaffSelectorBase.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({ default: "" })
], StaffSelectorBase.prototype, "placeholder", void 0);
tslib_1.__decorate([
    Prop({ default: "id" })
], StaffSelectorBase.prototype, "convertKey", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], StaffSelectorBase.prototype, "keepDeptIds", void 0);
tslib_1.__decorate([
    Prop({
        default: true,
    })
], StaffSelectorBase.prototype, "appManagerFilter", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: "input"
    })
], StaffSelectorBase.prototype, "displayType", void 0);
tslib_1.__decorate([
    Watch("value", {
        immediate: true,
        deep: true,
    })
], StaffSelectorBase.prototype, "setValue", null);
tslib_1.__decorate([
    Watch("options", {
        immediate: true,
    })
], StaffSelectorBase.prototype, "handleFocus", null);
